module.exports = __webpack_public_path__ + "img/5.9617fc14.png";